import React from 'react';
import { useTranslation } from 'react-i18next';

import { useHomePageContext } from '@/modules/home/context';
import OnlyDatePicker from '@/shared/components/molecules/CustomDatePicker/OnlyDatePicker';

import Calender from '~/images/shared/calender.svg';

const DateSelector = () => {
  const { t } = useTranslation('common');
  const {
    state: { date },
    setDate,
  } = useHomePageContext();

  return (
    <div className='mb-12 flex items-center gap-2'>
      <div className='flex items-center gap-2 leading-none'>
        <span className='text-primary-default'>
          <Calender />
        </span>
        <span className='text-18 font-bold text-text-default'>
          {t('day-overview')}
        </span>
      </div>
      <OnlyDatePicker
        defaultDate={date}
        onlyDatePicker
        onChange={setDate}
        showIcon={false}
        todayMax={false}
      />
    </div>
  );
};
export { DateSelector };
